import { useState } from "react";
import { Share2, Handshake, SlidersHorizontal } from "lucide-react";
import { ParallaxScene, ParallaxLayer } from "../ParallaxScene";
import { trustPillars } from "../../data/phase3Content";
import { PrivacySelector } from "./PrivacySelector";
import { Words } from "../Words";

const ICONS = { share: Share2, consent: Handshake, control: SlidersHorizontal };
const DEPTH = [[30, -20], [70, -40], [45, -30]];

export default function TrustSection() {
  const [audience, setAudience] = useState("selected");
  return (
    <ParallaxScene as="section" id="trust" offset={["start end", "end start"]} data-testid="section-trust" className="trust-stage relative overflow-hidden pb-28 pt-28 lg:pb-40 lg:pt-40">
      <div className="relative mx-auto max-w-[1240px] px-5 lg:px-10">
        <p className="eyebrow">08 · Built around trust</p>
        <h2 className="h-section mt-4 text-[#08090D]" data-testid="trust-headline">
          <Words text="Your People." />
          <br />
          <Words text="Your Privacy." start={2} className="text-[#777B8D]" />
          <br />
          <Words text="Your Choice." start={4} className="text-gradient" />
        </h2>
        <p className="mt-6 max-w-[560px] text-[18px] leading-relaxed text-[#4c5064] sm:text-[20px]">
          Meaningful connections begin with trust. You decide what you share, who sees it and what your AI can do.
        </p>

        <div className="relative mt-16 lg:mt-24">
          <div className="trust-wash pointer-events-none absolute inset-x-[4%] top-[12%] h-[76%] rounded-[80px]" aria-hidden />
          <div className="relative grid gap-5 md:grid-cols-3 lg:gap-7">
            {trustPillars.map((t, i) => {
              const Icon = ICONS[t.id];
              return (
                <ParallaxLayer key={t.id} y={DEPTH[i]}>
                  <article className="glass glass-heavy flex h-full min-h-[280px] flex-col rounded-[36px] p-7 lg:min-h-[340px] lg:p-9" data-testid={`trust-pillar-${t.id}`}>
                    <span className="grid h-12 w-12 place-items-center rounded-2xl border border-[#08090D]/10 bg-white/70 text-[#08090D]">
                      <Icon size={20} strokeWidth={1.6} aria-hidden />
                    </span>
                    <h3 className="mt-auto pt-10 text-[28px] font-bold leading-[1.05] tracking-[-0.035em] text-[#08090D] lg:text-[34px]">{t.title}</h3>
                    <p className="mt-3 text-[16px] leading-relaxed text-[#3c4052]">{t.body}</p>
                  </article>
                </ParallaxLayer>
              );
            })}
          </div>
        </div>

        <div className="mt-12 lg:mt-20">
          <PrivacySelector value={audience} onChange={setAudience} />
        </div>
      </div>
    </ParallaxScene>
  );
}
